import { db } from "../firebaseClient"
import { doc, collection, setDoc, getDocs, query, where, serverTimestamp } from "firebase/firestore"

// Append-only log of product/course detail-page views — the top of the funnel.
// One event per page load; dedupe/session-windowing can be added later if
// view counts need to exclude repeat visits from the same learner.
export const logProductView = async ({ orgId, productId, productType, viewerId }) => {
  if (!orgId || !productId) return { error: null }
  try {
    const ref = doc(collection(db, "productViews"))
    await setDoc(ref, {
      orgId,
      productId,
      productType: productType || "course",
      viewerId: viewerId || null,
      createdAt: serverTimestamp(),
    })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const listOrgProductViews = async (orgId) => {
  try {
    const ref = collection(db, "productViews")
    const q = query(ref, where("orgId", "==", orgId))
    const snap = await getDocs(q)
    return { views: snap.docs?.map((d) => d.data()), error: null }
  } catch (error) {
    return { views: [], error }
  }
}